import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { usePopper as useBasePopper } from 'react-popper';
type UsePopperReturn = {
  popper: ReturnType<typeof useBasePopper>;
  setReferenceElement: (element: HTMLElement | null) => void;
  setPopperElement: (element: HTMLUListElement | null) => void;
};
const usePopper = () => {
  const $ = _c(3);
  const [referenceElement, setReferenceElement] = useState();
  const [popperElement, setPopperElement] = useState();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      modifiers: [{
        name: "offset",
        options: {
          offset: [0, 8]
        }
      }]
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const popper = useBasePopper(referenceElement, popperElement, t0);
  let t1;
  if ($[1] !== popper) {
    t1 = {
      popper,
      setReferenceElement,
      setPopperElement
    };
    $[1] = popper;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default usePopper;